import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { ConfigService } from '../../config/config.service';
import { Album } from '../models/gallery.model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {
  private albumsCache$?: Observable<Album[]>;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private router: Router,
  ) { }

  private get baseUrl(): string {
    return this.configService.get()?.END_POINT || '';
  }

  getAlbums(forceRefresh = false): Observable<Album[]> {
    if (!this.albumsCache$ || forceRefresh) {
      const headers = new HttpHeaders({
        'APP_FLAVOUR': window.location.hostname
      });

      this.albumsCache$ = this.http.get<any>(`${this.baseUrl}/api/front-end/album/getAll`, { headers }).pipe(
        map(res => {
          let data = res;
          if (data && typeof data === 'object' && !Array.isArray(data)) {
            data = data.responseData || data.data || data.albums || [];
          }
          return Array.isArray(data) ? data : [];
        }),
        shareReplay(1)
      );
    }
    return this.albumsCache$;
  }

  getImageUrl(pictureDetailsSeq: number): string {
    return `${this.baseUrl}/api/front-end/gallery/getImage/${pictureDetailsSeq}`;
  }
  
}



